
import { computed, defineComponent, Ref, ref, toRef, watch } from 'vue';
import { Field, useField } from 'vee-validate';
import { CustomInputFieldInternalValue } from '@/shared/form/validation.plugin';

export default defineComponent({
    name: 'InputSelect',
    components: { Field },
    props: {
        id: {
            type: String,
            required: false,
            default: null,
        },
        value: {
            type: [String, Object, Boolean, Number],
            required: false,
            default: '',
        },
        // eslint-disable-next-line vue/require-default-prop
        modelValue: {
            type: null,
        },
        name: {
            type: String,
            required: true,
        },
        showErrors: {
            type: Boolean,
            required: false,
            default: true,
        },
        label: {
            type: String,
            required: false,
            default: '',
        },
        highlighted: {
            type: Boolean,
            required: false,
            default: false,
        },
        rules: {
            type: String,
            default: '',
        },
    },
    emits: {
        'update:modelValue': (value) => true,
    },
    setup(props, { attrs, emit }) {
        const internalValue: Ref<CustomInputFieldInternalValue> = ref(null);
        const isFocused: Ref<boolean> = ref(false);

        const isModelBound = computed(() => {
            return 'modelValue' in props;
        });

        const fieldRules = computed(() => props.rules);
        const { value: fieldInternalValue } = useField<string | undefined>(props.name, fieldRules.value);

        const fieldId = computed(() => {
            return props.id || props.name + new Date().valueOf();
        });

        const fieldAttrs = computed(() => {
            return {
                ...attrs,
                class: '',
            };
        });

        const handleChange = () => {
            let value = internalValue.value;

            if (value === 'true') {
                value = true;
            } else if (value === 'false') {
                value = false;
            }
            emit('update:modelValue', value);
        };

        if (isModelBound.value) {
            const modelValue = toRef(props, 'modelValue');
            watch(modelValue, newModelValue => {
                if (newModelValue !== internalValue.value) {
                    internalValue.value = newModelValue;
                }
            }, { immediate: true });
        } else {
            internalValue.value = props.value as CustomInputFieldInternalValue;
        }

        return {
            isFocused,
            fieldId,
            fieldAttrs,
            internalValue,
            handleChange,
            fieldRules,
            fieldInternalValue,
        };
    },
});

